import React, {useEffect, useState} from "react";
import {Button, Card, Divider, IconButton, Stack, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {dataManager} from "../../Broadtask";
import GridViewIcon from "@mui/icons-material/GridView";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExtensionCard from "./ExtensionCard";
import {ExtensionOffOutlined, ExtensionOutlined, MapTwoTone, RefreshOutlined} from "@mui/icons-material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ExtensionInstaller from "../../pages/extension/ExtensionInstaller";
import TaskableCard from "../taskable/TaskableCard";
import HideShowButton from "../HideShowButton";
import {buttonStyle, sectionStack} from "../../../AppStyles";

const ExtensionSelectPane = (props) => {

    const navigate = useNavigate();
    const [extensions, setExtensions] = useState(null);

    const [showPanel, setShowPanel] = useState(true);

    useEffect(() => {
        reload(false);
    }, []);

    function reload(force)
    {
        dataManager.getExtensionManager().getExtensions(force, (extensions) => {
            setExtensions(extensions);
        });
    }

    function onRefresh()
    {
        reload(true);
    }

    function onView()
    {
        navigate("/extensions");
    }

    function onInstall()
    {
        navigate("/extensions/install");
    }

    function onTogglePanel()
    {
        setShowPanel(!showPanel);
    }

    function onScrollExtensions()
    {

    }


    return (
        <Stack direction="column" spacing={1} padding={1} width="100%" alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%" justifyContent="space-between" alignItems="left">
                <Stack direction="row" alignItems="left">
                    <img src="/icons/extension.png" width={58} height={58}/>
                    <Stack direction="column" width="100%" alignItems="flex-start" justifyContent="flex-start">
                        <Typography color="#84898D" variant="subtitle1">EXTENSIONS</Typography>
                        <Typography color="#495D67" variant="subtitle2" alignItems="left">MAINTAIN EXTENSION FOR ACCOUNT</Typography>
                    </Stack>
                </Stack>
                <Stack direction="row" spacing={1} padding={1} alignItems="center">
                    <Card variant="outlined"
                          sx={{
                              display: 'flex',
                              color: '#f9a555',
                              backgroundColor: '#141c21',
                              '& svg': {
                                  m: 1,
                              },
                              '& hr': {
                                  mx: 0.5,
                              },
                          }}
                    >
                        <Button onClick={onRefresh}
                                sx={buttonStyle}
                                startIcon={<RefreshOutlined />}>REFRESH</Button>
                        <Divider orientation="vertical" variant="middle" flexItem />
                        <Button onClick={onInstall}
                                sx={buttonStyle}
                                startIcon={<CloudUploadIcon />}>INSTALLER</Button>
                        <Divider orientation="vertical" variant="middle" flexItem />
                        <Button onClick={onView}
                                sx={buttonStyle}
                                startIcon={<ExtensionOutlined />}>MANAGE EXTENSIONS</Button>
                    </Card>
                    <HideShowButton onChange={onTogglePanel} />
                </Stack>
            </Stack>
            {
                showPanel === false ?
                <></> :
                <Stack direction="column" width="100%">
                    <Divider orientation="horizontal" variant="CENTER" width="100%" flexItem>
                        <Typography fontSize="small" sx={{ color: '#808183'}}>EXTENSIONS</Typography>
                    </Divider>
                    <Stack direction="row" width="100%" alignItems="center">
                        <IconButton onClick={onScrollExtensions} title="Scroll Left"
                                    sx={{ backgroundColor: '#2A333A',color:'#f9a555', width: 36, height: 36,transform: 'rotate(270deg)'}} >
                            <img src="/icons/arrow.png" width={16} height={16} />
                        </IconButton>
                        <Stack direction="row" alignItems="center" spacing={1} padding={1} width="100%" minHeight={100}
                               useFlexGap sx={{ flexWrap: "wrap", backgroundColor: '#2A333A'}}>
                            {
                                extensions === null ?
                                    <Typography variant="h6">Loading...</Typography>:
                                    extensions.map(nextExt => {
                                        return (<ExtensionCard key={"ext_" + nextExt.extensionUID} entry={nextExt} />)
                                    })
                            }
                        </Stack>
                        <IconButton onClick={onScrollExtensions} title="Scroll Right"
                                    sx={{ backgroundColor: '#2A333A',color:'#f9a555', width: 36, height: 36,transform: 'rotate(90deg)'}} >
                            <img src="/icons/arrow.png" width={16} height={16} />
                        </IconButton>
                    </Stack>
                    <Divider orientation="horizontal" variant="left" flexItem />
                </Stack>
            }
        </Stack>
    );
}

export default ExtensionSelectPane;
